import type { ApiError } from 'modules/global/generic.types';
import * as types from 'modules/tireScan/actionTypes';
import type { ImportSource } from 'modules/tireScan/constants';
import type { FetchTireScansFailureAction } from 'modules/tireScan/types';
import { createReducer, sourceMatcher } from 'utils/ReduxUtils';

export type TireScanImportErrorReducer = ApiError | null;

const initialState: TireScanImportErrorReducer = null;

const beforeFetch = (): TireScanImportErrorReducer => initialState;

const onFailure = (_: TireScanImportErrorReducer, { payload }: FetchTireScansFailureAction): TireScanImportErrorReducer =>
  payload;

const reducer = (source: ImportSource) =>
  createReducer<TireScanImportErrorReducer>(initialState, {
    [types.FETCH_TIRE_SCAN_REQUEST]: sourceMatcher(source, beforeFetch),
    [types.FETCH_TIRE_SCAN_FAILURE]: sourceMatcher(source, onFailure),
  });

export default reducer;
